module.exports = __webpack_public_path__ + "img/etmatmos_gel_hover.69e18c40.png";